export default "__VITE_ASSET__FVnW0dQf__"